// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iuyY","label":"styles_label__2KAPO"};